import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { useTranslation } from '@yme/services/i18n';
import { RegularTextLevel4 } from '@yme/tokens/typography';
import { getDidYouMeanMessage, getSearchResultLinkParams } from './helpers';
import { DidYouMeanWrapperStyled, LinkWrapperStyled } from './styled';
export function DidYouMean({ value, autoCorrectQuery, searchResultsPageUrl, onClickLink, }) {
    const { t } = useTranslation();
    const didYouMeanMessage = getDidYouMeanMessage(t('globalSearch_noResultsDidYouMean_message'), value, autoCorrectQuery);
    return (React.createElement(DidYouMeanWrapperStyled, null,
        React.createElement(LinkWrapperStyled, { hasBackground: true, to: {
                pathname: searchResultsPageUrl,
                search: getSearchResultLinkParams(autoCorrectQuery),
            }, onClick: onClickLink },
            React.createElement(RegularTextLevel4, { dangerouslySetInnerHTML: {
                    __html: sanitizeHtml(didYouMeanMessage),
                } }))));
}
